import { ThemeColors } from "../typings";

export const themeColors = {
  text: ["headingsAndLinksColor", "bodyTextColor", "priceColor", "salePriceColor"] as ThemeColors[],
  primaryBtn: ["primaryBtnBgColor", "primaryBtnBorderColor", "primaryBtnLabelColor"] as ThemeColors[],
  secondaryBtn: ["secondaryBtnBgColor", "secondaryBtnBorderColor", "secondaryBtnLabelColor"] as ThemeColors[],
  formFields: ["formFieldsBgColor", "formFieldsBorderColor", "formFieldsLabelColor"] as ThemeColors[],
  pages: ["pageBgColor", "pageBordersAndLinesColor"] as ThemeColors[],
};
